import { render, staticRenderFns } from "./outTab2.vue?vue&type=template&id=2d836282&scoped=true&"
import script from "./outTab2.vue?vue&type=script&lang=js&"
export * from "./outTab2.vue?vue&type=script&lang=js&"
import style0 from "./outTab2.vue?vue&type=style&index=0&id=2d836282&scoped=true&lang=css&"
import style1 from "./outTab2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d836282",
  null
  
)

export default component.exports